// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { RegistrarBatchOperations } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useRegistrarBatchOperations: () => UseQueryResult<
  TemplateContract<RegistrarBatchOperations>[],
  string
> = () =>
  useOperatorBasedQuery('queryRegistrarBatchOperations', (ledgerApi, offset, operator) =>
    ledgerApi.queryRegistrarBatchOperations(offset, operator),
  );

export default useRegistrarBatchOperations;
